<template lang="pug">
  .tour(:style="{ height }")
    global-events(v-if="tourShown", @keyup.n="nextStep", @keyup.p="prevStep", @keyup.m="learnMore", @keyup.l="learnMore", @keyup.esc.capture="tourShown = false")
    //-.area
      .highlight one
      .highlight two
    .mask(ref="mask", @click="all = !all", :style="{ 'clip-path': clipPath, height }")
    transition
      .annotations(v-if="(tourStep || currentStep || {}).annotations")
        .annotation(v-for="annotation in (tourStep || currentStep || {}).annotations",
                    :class="{ small: annotation.small }",
                    :style="annotationStyle(annotation)")
          .line
          .text(:text="annotation.text") {{ annotation.text }}
    .click-here(:class="{ show: tourStep && tourStep.pointer }", :style="clickHereStyle") click here
    .guide(:class="{ 'in-tour': step !== -1 }", :style="styleNudge")
      .close(@click="tourShown = false", title="exit tour") &times;
      .weavy
        .bars
          .bar.tall.gap
          .bar
          .bar
          .bar.tall
          .bar.gap
          .bar.tall
          .bar
          .bar.tall
          .bar.tall
        .eyes
          .eye
          .eye
        .lines
          .line
          .line
          .line
          .line
          .line
          .line
      .title Weave tour
      .steps
        .step(v-for="({ title }, index) in (tour || {}).steps || []",
              @click="step = index",
              :class="{ on: index === step }",
              :title="title")
          //.title {{ title }}
      .content
        .title(@click="nextStep") {{ currentStep && currentStep.title || 'click to begin' }}
        .description(v-if="currentStep && currentStep.description").
          {{ tourStep && tourStep.description || currentStep && currentStep.description }}
        .learn-more(:class="{ show: currentStep && currentStep.steps && !tourInTour }", @click="learnMore") learn more
      .prev-next
        .prev(@click="prevStep") &#8678;
        .next(@click="nextStep") &#8680;
    //-.blue
</template>
<script>
import { mapGetters } from 'vuex';
import { vuexComputed } from '@/helpers';
export default {
  props: {
    tour: Object
  },
  data() {
    return { all: true, ready: false, height: 0, lastTourStep: null };
  },
  watch: {
    loader() {
      this.setHeight();
    },
    step(newValue, oldValue) {
      // todo: keep track of lastValue so that close restores prior state
      const steps = this.tour?.steps || [];
      //console.log('step watcher', steps[newValue], steps);
      const { open = () => 1 } = steps?.[newValue] || {};
      open();
      const { close = () => 1 } = steps?.[oldValue] || {};
      close();
      this.tourInTour = false;
      this.tourInTourStep = -1;
    },
    async tourInTourStep(newValue, oldValue) {
      const { tourInTour } = this;
      if (newValue > -1 && newValue !== oldValue && tourInTour) {
        const { open = () => 1 } = this.currentStep?.steps?.[newValue] || {};
        await open();
      }
      if (this.lastTourStep) {
        console.log('last tour step close');
        const { close = () => 1 } = this.lastTourStep || {};
        await close();
      }
      if (tourInTour && newValue > -1) {
        this.lastTourStep = this.tourStep;
      } else {
        this.lastTourStep = null;
      }
    },
    async engagePub(newValue) {
      const { tourStep, tourShown, currentStep } = this;
      const title = 'explore holdings';
      const titleMatch = tourStep?.title === title || currentStep?.title === 'holdings';
      if (tourShown && titleMatch && newValue) {
        //console.log('engagePub watcher', tourStep);
        await (this.tourInTour = true);
        await (this.tourInTourStep = 1);
      } else if (tourShown && tourStep && !newValue && titleMatch) {
        await (this.tourInTourStep = -1);
        await (this.tourInTour = false);
      }
    },
    async engageTheme(newValue) {
      const { tourStep, tourShown, currentStep } = this;
      const title = 'explore themes';
      const titleMatch = tourStep?.title === title || currentStep?.title === title;
      console.log('engageTheme watcher', tourStep, titleMatch, newValue, tourShown, 'titles', tourStep?.title, currentStep?.title);
      if (tourShown && titleMatch && newValue) {
        //console.log('engageTheme watcher', tourStep);
        await (this.tourInTour = true);
        await (this.tourInTourStep = 1);
      } else if (tourShown && tourStep && !newValue && titleMatch) {
        await (this.tourInTourStep = -1);
        await (this.tourInTour = false);
      }
    },
    pdf(newValue, oldValue) {
      const { tourStep, tourInTourStep, currentStep, tourShown, tourInTour } = this;
      const title = 'explore key documents';
      const titleMatch = tourStep?.title === title || currentStep?.title === 'key documents';
      console.log('pdf watcher', tourStep, titleMatch, newValue, tourShown, 'titles', tourStep?.title, currentStep?.title);
      if (newValue && tourShown && titleMatch) {
        console.log('pdf watcher', tourStep, currentStep, tourInTour, tourInTourStep);
        this.tourInTour = true;
        this.tourInTourStep = 1;
      } else if (tourStep && !newValue && titleMatch && tourInTourStep > 0) {
        this.tourInTour = false;
        this.tourInTourStep = 0;
      }
    },
    engageSelectedSection(newValue, oldValue) {
      const { tourStep, tourInTourStep, currentStep, tourShown, tourInTour } = this;
      const title = 'section viewer';
      const titleMatch = tourStep?.title === title || currentStep?.title === 'sections';
      console.log('engageSelectedSection watcher', tourStep, titleMatch, newValue, tourShown, 'titles', tourStep?.title, 55, currentStep?.title);
      if (newValue && tourShown && titleMatch) {
        console.log('engageSelectedSection watcher', tourStep, currentStep, tourInTour, tourInTourStep);
        this.tourInTour = true;
        // this.tourInTourStep = tourInTourStep === 0 && 1 || 0;
        this.tourInTourStep = 1;
      } else if (tourStep && !newValue && titleMatch) {
        this.tourInTour = false;
        this.tourInTourStep = -1;
      }
    },
    engageLinksShown(newValue, oldValue) {
      const { tourStep, currentStep } = this;
      const title = 'show contact us';
      const titleMatch = tourStep?.title === title || currentStep?.title === 'contact us';
      console.log('engageLinksShown watcher', tourStep, tourStep?.title || 'no title', titleMatch, newValue, !oldValue);
      if (newValue && !oldValue && titleMatch) {
        console.log('engageLinksShown watcher if', tourStep);
        this.tourInTour = true;
        this.tourInTourStep = 0;
      } else if (tourStep && !newValue && titleMatch) {
        console.log('engageLinksShown watcher else', tourStep);
        this.tourInTour = false;
        this.tourInTourStep = -1;
      }
    },
    engageNotificationsShown(newValue, oldValue) {
      const { tourStep, currentStep } = this;
      const title = 'show notifications';
      const titleMatch = tourStep?.title === title || currentStep?.title === 'notifications';
      console.log('engageNotificationsShown watcher', tourStep, tourStep?.title || 'no title', titleMatch, newValue, !oldValue);
      if (newValue && !oldValue && titleMatch) {
        console.log('engageNotificationsShown watcher if', tourStep);
        this.tourInTour = true;
        this.tourInTourStep = 0;
      } else if (tourStep && !newValue && titleMatch) {
        console.log('engageNotificationsShown watcher else', tourStep);
        this.tourInTour = false;
        this.tourInTourStep = -1;
      }
    }
  },
  computed: {
    ...mapGetters([
      'engage',
      'engagePub',
      'engageTheme',
      'pdf',
      'engageLinksShown',
      'currentStep',
      'engageNotificationsShown',
      'engageSelectedSection'
    ]),
    ...vuexComputed('engageTourStep', 'tourInTour', 'tourInTourStep', 'tourShown'),
    step: {
      get() {
        return this.engageTourStep;
      },
      set(value) {
        this.engageTourStep = value;
      }
    },
    currentStep() {
      const { tour: { steps }, step } = this;
      return steps?.[step];
    },
    tourStep() {
      const { tourInTour, tourInTourStep, currentStep } = this;
      let r;
      if (tourInTour && tourInTourStep > -1) {
        r = currentStep?.steps?.[tourInTourStep];
      }
      return r;
    },
    styleNudge() {
      const { tourStep, currentStep } = this;
      return (tourStep || currentStep || {}).styleNudge || {};
    },
    clickHereStyle() {
      //console.log('clickHereStyle', this.tourStep?.boxes);
      const [{ bottom, right } = {}] = this.tourStep?.boxes || [{}];
      return { top: bottom + 'px', left: right + 'px' };
      //return this.tourStep.boxes;
    },
    clipPath() {
      const { tour: { steps }, step, currentStep, tourInTour, tourStep } = this;
      // console.log('steps', JSON.stringify(steps, null, 2));
      //console.log('clipPath', currentStep);
      return this.ready && stepsTopPoly('100% 50%') || '';
      function stepsTopPoly(xy) {
        let { boxes } = step > -1 && currentStep || steps.reduce((all, step) => {
          all.boxes = [];
          // all.boxes = all.boxes.concat(step.boxes);
          return all;
        }, { boxes: [] });
        if (tourInTour) {
          boxes = tourStep?.boxes || boxes;
        }
        return `polygon(100% 50%, 100% 100%, 0 100%, 0 0, 100% 0, 100% 50%, ${ boxes.map(stepToCutOut).join(', ') }, 100% 50%)`;
        //const r = `polygon(100% 50%, 100% 100%, 0 100%, 0 0, 100% 0, 100% 50%, ${ boxes.map(stepToCutOut).join(', ') }, 100% 50%)`;
        //return r;
        // console.log('dtp', r);
        /*
        */
        // function stepToCutOut(div) {
        // function stepToCutOut({ top, left, bottom, right }) {
        function stepToCutOut(box) {
          const [x, y] = xy.split(' ');
          // const box = div.getBoundingClientRect();
          // const { top, left, bottom, right } = box;
          //const padding = 2;
          const lastDigit = (new Date() * 1 + '').substr(-1, 1) * 1;
          const zoom = lastDigit > 8 ? 4 : 0;
          const nudge = (lastDigit > 8 && 4) || (lastDigit > 6 && -4) || 0;
          const top = box.top - zoom;// + nudge;
          const left = box.left - zoom + nudge;
          const bottom = box.bottom + zoom;// + nudge;
          const right = box.right + zoom + nudge;
          const radius = 8;
          const corners = [
            ['100%', y],

            ['100%', top],
            [left + radius, top],
            ...arc(left + radius, top + radius, 'ws'),
            [left, bottom - radius],
            ...arc(left + radius, bottom - radius, 'se'),
            [right - radius, bottom],
            ...arc(right - radius, bottom - radius, 'en'),
            [right, top + radius],
            ...arc(right - radius, top + radius, 'nw'),
            ['100%', top],

            ['100%', y],
            [x, y]
          ].map(xy =>
            xy
              .map(v => v + 'px')
              .join(' ')
              .replace(/\%px/g, '%')
          );
          // const corners = [
          //   ['100%', y],
          //
          //   ['100%', top],
          //   [left, top],
          //   [left, bottom],
          //   [right, bottom],
          //   [right, top],
          //   ['100%', top],
          //
          //   ['100%', y],
          //   [x, y]
          // ].map(xy => xy.map(v => v + 'px').join(' ').replace(/\%px/g, '%'));
          return corners.join(', ');
        }
      }
    }
  },
  methods: {
    annotationStyle({ top, left, bottom, right, position }) {
      const r = {};
      if (top && positionHas('top')) {
        r.top = top + 'px';
      }
      if (left && positionHas('left')) {
        r.left = left + 'px';
      }
      if (position) {
        if (bottom && positionHas('bottom')) {
          r.top = bottom + 'px';
        }
        if (right && positionHas('right')) {
          r.left = right + 'px';
        }
      }
      return r;
      function positionHas(prop) {
        return !position || new RegExp(prop).test(position);
      }
    },
    prevStep() {
      const { tour, step } = this;
      if (tour?.steps?.[step - 1]) {
        this.step--;
      } else {
        this.step = tour?.steps?.length - 1 || 0;
      }
    },
    nextStep() {
      const { tour, step } = this;
      if (tour?.steps?.[step + 1]) {
        this.step++;
      } else {
        this.step = 0;
      }
    },
    async learnMore() {
      await (this.tourInTour = true);
      await (this.tourInTourStep = 0);
    },
    setHeight() {
      console.log('setHeight');
      //this.height = document.body.scrollHeight + 'px';
      const body = document.body;
      const html = document.documentElement;
      this.height =
        Math.max(body.scrollHeight, body.offsetHeight, html.clientHeight, html.scrollHeight, html.offsetHeight) + 'px';
    }
  },
  mounted() {
    this.setHeight();
    this.ready = true;
  }
};
function arc(sx, sy, bend = 'nw') {
  let precision = 64;
  let radius = 8;
  let c = [...Array(precision)].map((_, i) => {
    let a = (-i / (precision - 1)) * Math.PI * 2;
    let x = Math.cos(a) * radius + sx;
    let y = Math.sin(a) * radius + sy;
    return [x, y];//.map(Math.round); //`${ Math.round(x) } ${ Math.round(y) }`;
  });
  const start = { nw: 0, ws: 16, se: 32, en: 48 }[bend];
  return c.slice(start, start + (precision / 4 + 1));
}
function circle() {
  let precision = 64;
  let radius = 60;
  let c = [...Array(precision)].map((_, i) => {
    let a = (-i / (precision - 1)) * Math.PI * 2;
    let x = Math.cos(a) * radius + 50;
    let y = Math.sin(a) * radius + 50;
    return `${x}% ${y}%`;
  });
}

</script>
<style>
body {
  margin: 0;
}
</style>
<style lang="scss" scoped>
@import '../scss/global';
.tour {
  position: absolute;
  top: 0;
  left: 0;
  z-index: 20000;
  &:hover {
    .mask {
      backdrop-filter: blur(2px) grayscale(80%);
    }
  }
  & > .guide {
    position: fixed;
    top: 3rem;
    //left: 40%;
    left: 54%;
    z-index: 3;
    user-select: none;
    box-sizing: border-box;
    padding: 1rem 0.5rem 0.5rem 2.5rem;
    border-radius: 1rem;
    //background-color: orange;
    background-color: rgba(orange, 0.6);
    backdrop-filter: blur(4px);
    border: 1px solid transparent;
    border-top-color: white;
    border-left-color: white;
    //clip-path: inset(4rem 3rem 6rem 8rem round 0.75rem);
    //border: 2px solid white;
    //box-shadow: 0 0 4px black;
    box-shadow: 4px 4px 8px rgba(black, 0.5);
    transition: all 400ms ease-in-out;
    &.in-tour {
      .prev-next {
        opacity: 1;
        pointer-events: all;
      }
    }
    & > .close {
      cursor: pointer;
      position: absolute;
      top: -0.5rem;
      right: 0.5rem;
      font-size: 2rem;
      padding-top: 0;
      padding-left: 0.5rem;
      color: white;
      opacity: 0.7;
      will-change: opacity;
      transition: opacity 250ms ease-in-out;
      &:hover {
        opacity: 1;
      }
    }
    & > .weavy {
      position: absolute;
      top: 0.5rem;
      left: 0.5rem;
      transform: scale(3.75);
      //transform-origin: center;
      width: 1.25rem;
      height: 1.25rem;
      z-index: 4;
      background-color: $brn;
      border-radius: 0.25rem;
      overflow: hidden;
      //opacity: 0.75;
      box-sizing: border-box;
      border: 2px solid white;
      box-shadow: 0 0 3px rgba(black, 0.5);
      transition: opacity 250ms ease-in-out;
      &:hover,
      &.on {
        opacity: 1;
      }
      .eyes {
        position: absolute;
        top: 0.25rem;
        left: 0;
        right: 0;
        display: flex;
        justify-content: space-evenly;
        .eye {
          width: 0.25rem;
          height: 0.25rem;
          background-color: white;
          border: 1px solid #282828;
          border-radius: 50%;
          & + .eye {
            background-color: orange;
          }
        }
      }
      > .bars {
        position: absolute;
        width: 50%;
        left: 50%;
        > .bar {
          padding-top: 0;
          height: 1px;
          background-color: white;
          margin-top: 1px;
          &.tall {
            height: 2px;
          }
          &.gap {
            margin-bottom: 2px;
          }
        }
      }
    }
    & > .title {
      position: relative;
      left: -1rem;
      font-family: 'Assistant', sans-serif;
      color: white;
      font-weight: 500;
      font-size: 2rem;
      text-align: center;
      text-transform: uppercase;
    }
    & > .steps {
      $width: 1.125rem;
      position: absolute;
      top: 4.75rem;
      left: 0.5rem;
      //width: $width;
      & > .step {
        cursor: pointer;
        height: 0.5rem;
        margin-bottom: 0.25rem;
        box-sizing: border-box;
        width: $width;
        border: 1px solid white;
        //border-radius: 0.06125rem;
        transition: all 250ms ease-in-out;
        &.on {
          background-color: white;
        }
      }
    }
    & > .content {
      min-width: 25rem;
      max-width: 30rem;
      min-height: 10rem;
      padding: 0.5rem;
      border-radius: 0.75rem;
      margin: 1rem 0 0;
      //background-color: rgba(white, 0.5);
      background-color: white;
      //backdrop-filter: blur(4px);
      & > .title {
        cursor: pointer;
        white-space: nowrap;
        margin-bottom: 0.5rem;
        text-align: center;
        font-size: 1.6rem;
        text-transform: uppercase;
      }
      & > .description {
        border-top: 1px solid rgba(black, 0.25);
        padding-top: 0.5rem;
      }
      & > .learn-more {
        cursor: pointer;
        position: absolute;
        bottom: 0.75rem;
        right: 1.25rem;
        white-space: nowrap;
        font-family: 'Assistant', sans-serif;
        font-size: 1.25rem;
        color: $brn;
        transition: all 250ms ease-in-out;
        opacity: 0;
        pointer-events: none;
        &.show {
          opacity: 1;
          pointer-events: all;
        }
        &:hover {
          color: black;
        }
      }
    }
    & > .prev-next {
      position: absolute;
      top: 0;
      right: 0.5rem;
      opacity: 0;
      pointer-events: none;
      transition: opacity 400ms ease-in-out;
      display: grid;
      grid-template-columns: repeat(2, 1fr);
      grid-column-gap: 0.125rem;
      & > .prev,
      & > .next {
        cursor: pointer;
        // background-color: orange;
        border-radius: 0.25rem;
        box-sizing: border-box;
        padding: 0.25rem 0.5rem;
        color: white;
        font-size: 2rem;
        font-weight: 500;
        text-align: center;
        &::after {
          pointer-events: none;
          position: absolute;
          top: 1.25rem;
          right: 1.8rem;
          color: white;
          content: 'prev';
          font-size: 1rem;
          line-height: 2.9rem;
          // margin: 0.25rem;
          padding: 0.25rem 0.25rem 0.25rem 0.5rem;
          border-radius: 0.25rem;
          //background-color: orange;
          opacity: 0;
          user-select: none;
          transition: opacity 250ms ease-in-out 100ms;
        }
        &:hover {
          z-index: 1;
          &::after {
            opacity: 1;
          }
        }
        &.prev {
          // right: 4rem;
          //transform: translate3d(3px, 0, 0);
          border-top-right-radius: 0;
          border-bottom-right-radius: 0;
          // box-shadow: -3px 0 1px black;
        }
        &.next {
          // right: 0;
          //transform: translate3d(-3px, 0, 0);
          border-top-left-radius: 0;
          border-bottom-left-radius: 0;
          // box-shadow: 3px 0 1px black;
          &::after {
            // transform: translate3d(-100%, 0, 0);
            // right: 100%;
            content: 'next';
          }
        }
      }
    }
  }
  & > .click-here {
    position: absolute;
    pointer-events: none;
    padding: 1rem 1.5rem 1rem 3rem;
    background-color: orange;
    color: white;
    font-weight: 500;
    font-size: 1.2rem;
    z-index: 5;
    white-space: nowrap;
    background-color: rgba(orange, 0.9);
    backdrop-filter: blur(4px);
    //border: 1px solid white;
    //border-top-color: white;
    //border-left-color: white;
    //box-shadow: 4px 4px 8px rgba(black, 0.5);
    //border-radius: 0.5rem;
    clip-path: polygon(40% 0%, 40% 20%, 100% 20%, 100% 80%, 40% 80%, 40% 100%, 0% 50%);
    opacity: 0;
    transform: translate3d(0.5rem, -100%, 1px);
    transition: all 250ms ease-in-out;
    &.show {
      opacity: 1;
    }
  }
  & > .mask {
    pointer-events: none;
    position: absolute;
    top: 0;
    left: 0;
    // background-color: rgba(green, 0.8);
    //background-color: rgba(black, 0.65);
    //background-color: rgba(black, 0.2);
    background-color: rgba(black, 0.2);
    //backdrop-filter: blur(2px) grayscale(80%);
    //backdrop-filter: grayscale(80%);
    // height: 100vh;
    height: 100%;
    width: 100vw;
    z-index: 2;
    transition: clip-path 250ms ease-in-out;
  }
  & > .annotations {
    pointer-events: none;
    position: absolute;
    top: 0;
    left: 0;
    right: 0;
    //height: 100%;
    //width: 100vw;
    z-index: 3;
    & > .annotation {
      position: absolute;
      width: 2.5rem;
      height: 2.5rem;
      border: 4px solid rgba(orange, 0.75);
      border-radius: 0.5rem;
      box-shadow: 0 0 4px white,
                  inset 0 0 4px white;
      &.small {
        width: 1rem;
        height: 1rem;
      }
      & > .line {
        position: absolute;
        top: 50%;
        left: 100%;
        margin-top: -2px;
        margin-left: 4px;
        width: 15px;
        height: 4px;
        background-color: rgba(orange, 0.75);
      }
      & > .text {
        position: absolute;
        top: 50%;
        left: 100%;
        margin: -0.5rem 0 0 1.1rem;
        font-size: 1.2rem;
        font-family: 'Assistant', sans-serif;
        font-weight: 600;
        color: white;
        text-transform: uppercase;
        background-color: rgba(orange, 0.75);
        border-radius: 0.25rem;
        box-sizing: border-box;
        padding: 0.25rem 0.5rem;
        backdrop-filter: blur(2px);
        white-space: nowrap;
      }
    }
  }
}
</style>
